module.exports = __webpack_public_path__ + "bb11b557aa425a6367a9a627577a20de.pdf";